import { Button, Input, InputNumber, Spin, Upload, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBase64 } from "../../utils/history";
import { API_BASE_URL } from "../../config/serverApiConfig";
import { DEFAULT_AVATAR, ROLE_LABELS, dummyRequest } from "../hrRoles";
import { normalizeRole } from "../../pages/Auth/PermissionType";
import { updateNameAuth } from "../../slices/authentication.slice";
import { thumbSrc } from "../../utils/imageVariant";

function Profile() {
  const dispatch = useDispatch();
  const selectorAuth = useSelector((state) => state.auth.auth);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [age, setAge] = useState(null);
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (!selectorAuth.id) {
      setLoading(false);
      return;
    }
    axios
      .get(`${API_BASE_URL}user/${selectorAuth.id}`)
      .then((res) => {
        const row = res.data || {};
        setUser(row);
        setName(row.name || "");
        setUsername(row.username || "");
        setPhoneNumber(row.phoneNumber || "");
        setAge(row.age ?? null);
        if (row.image) dispatch(updateNameAuth({ name: row.name, img: row.image }));
      })
      .catch(() => message.error("نەتوانرا زانیاری ئەکاونت بهێنرێت"))
      .finally(() => setLoading(false));
  }, [selectorAuth.id, dispatch]);

  const photo = preview || (user?.image ? thumbSrc(user.image) : DEFAULT_AVATAR);

  const save = () => {
    if (!name.trim() || !username.trim()) {
      message.warning("ناو و ناوی بەکارهێنەر پێویستن");
      return;
    }
    const body = new FormData();
    if (file) body.append("image", file);
    body.append(
      "user",
      JSON.stringify({
        name: name.trim(),
        username: username.trim(),
        phoneNumber: phoneNumber.trim(),
        age: age || 0,
        gender: user?.gender || "",
        role: user?.role,
        status: user?.status !== false,
        password: password.trim() || user?.password || "",
      })
    );
    setSaving(true);
    axios
      .put(`${API_BASE_URL}user/${selectorAuth.id}`, body)
      .then((res) => {
        setUser(res.data);
        setPassword("");
        setFile(null);
        setPreview("");
        dispatch(updateNameAuth({ name: res.data.name, img: res.data.image }));
        message.success("زانیارییەکان پاشەکەوتکران");
      })
      .catch(() => message.error("نەتوانرا زانیارییەکان پاشەکەوت بکرێن"))
      .finally(() => setSaving(false));
  };

  if (loading) {
    return (
      <section className="settings-card settings-account">
        <Spin />
      </section>
    );
  }

  if (!user) {
    return (
      <section className="settings-card">
        <h3 className="settings-block-title">ئەکاونت</h3>
        <p className="settings-hint">ئەم ئەکاونتە لە سیستەم نەدۆزرایەوە. تکایە دووبارە بچۆ ژوورەوە.</p>
      </section>
    );
  }

  return (
    <section className="settings-card settings-account">
      <div className="settings-profile">
        <Upload
          listType="picture"
          showUploadList={false}
          customRequest={dummyRequest}
          beforeUpload={(next) => {
            const ok = next.type === "image/jpeg" || next.type === "image/png";
            if (!ok) message.error("تەنها وێنەی JPG یان PNG");
            return ok;
          }}
          onChange={(info) => {
            const next = info.file.originFileObj;
            if (!next) return;
            setFile(next);
            getBase64(next, setPreview);
          }}
        >
          <img className="settings-avatar" alt="" src={photo} />
        </Upload>
        <span className="settings-role">{ROLE_LABELS[normalizeRole(user?.role || selectorAuth.role)] || "ئەکاونت"}</span>
        <span className="settings-hint">وێنە بگۆڕە</span>
      </div>
      <div className="settings-fields">
        <label>
          ناو
          <Input value={name} onChange={(e) => setName(e.target.value)} size="large" />
        </label>
        <label>
          ناوی بەکارهێنەر
          <Input value={username} onChange={(e) => setUsername(e.target.value)} size="large" />
        </label>
        <label>
          ژمارەی مۆبایل
          <Input value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} size="large" />
        </label>
        <label>
          تەمەن
          <InputNumber value={age} min={0} onChange={setAge} size="large" style={{ width: "100%" }} />
        </label>
        <label className="settings-span">
          وشەی نهێنی نوێ
          <Input.Password value={password} onChange={(e) => setPassword(e.target.value)} size="large" placeholder="بەتاڵی بهێڵەوە ئەگەر ناگۆڕیت" />
        </label>
        <div className="settings-span">
          <Button type="primary" loading={saving} onClick={save}>
            پاشەکەوتکردن
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Profile;
